import Skeleton from "@Components/Skeleton";
import styles from "../../searchListItem.module.scss";
import useWhitelabel from "hooks/useWhitelabel";
import Button from "@Components/Button";
import ArrowIcon from "@Icons/ArrowIcon";
import wrapperHOC from "@Utils/wrapperHOC";
import useTranslationHook from "hooks/useTranslationHook";
// import Constant from "locales/lang"json"";

const SkeletonSearchListItem = ({ isDesktop = false }) => {
  const { isWhitelabel, universityMock } = useWhitelabel();
  const { t } = useTranslationHook();
  return (
    <div
      className={isDesktop ? styles.desktopContainer : styles.container}
      style={isDesktop ? { height: "212px" } : undefined}
    >
      <Skeleton width={isDesktop ? "345px" : "100%"} height="230px" />

      <div className={styles.contentSection}>
        <div className={styles.leftSection}>
          {!isDesktop && <Skeleton width="70%" height="20px" mb="8px" />}
          <Skeleton width={isDesktop ? "100%" : "40%"} height="16px" mt="8px" />
          <Skeleton
            width={isDesktop ? "80%" : "30%"}
            height="20px"
            mt={isDesktop ? "16px" : "84px"}
          />
          {isDesktop && (
            <>
              <Skeleton width="60%" height="12px" mt="16px" />
              <Skeleton width="100%" height="18px" mt="24px" />
              {isWhitelabel && universityMock && (
                <Button
                  RightIcon={() => <ArrowIcon rotate={270} />}
                  variant={isWhitelabel ? "whiteLabel_primary" : "primary"}
                  size="lg"
                  className={styles.skeletonButton}
                >
                  {t("searchpage.searchlist.skeletonsearchlistitem.viewproperty")}
                </Button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default wrapperHOC(SkeletonSearchListItem, {
  componentName: "SkeletonSearchListItem-SearchListItemDesktop-SearchPage",
  showForChina: true,
});
